import React, { useState } from "react";
import { Form, InputGroup, Button } from "react-bootstrap";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

const PasswordInput = ({ placeholder, value, onChange, isInvalid, isValid, error, name, ...props }) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Form.Group className="mb-3">
      <InputGroup>
        <Form.Control
          type={showPassword ? "text" : "password"}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          isInvalid={isInvalid}
          isValid={isValid}
          name={name}
          {...props}
        />
        <Button variant="outline-secondary" onClick={togglePasswordVisibility}>
          {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
        </Button>
        {isInvalid && (
          <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        )}
      </InputGroup>
    </Form.Group>
  );
};

export default PasswordInput;
